'use client';

import { VStack } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';
import type { WebAppSuggestedApplicationDto } from '@terra/shared-contracts-external-network';
import { Button } from '../../../../components/button';
import { AfterFactWebAppClusterLink } from './AfterFactWebAppClusterLink';
import type { LinkableWebApplication } from './web-app-types';

export type AfterFactWebAppClusterActionsProps = {
  applications: LinkableWebApplication[];
  suggestion?: WebAppSuggestedApplicationDto | null;
  onLinkExisting?: (applicationId: string) => void;
  onCreateDraft?: () => void;
  isCreatingDraft?: boolean;
};

export function AfterFactWebAppClusterActions({
  applications,
  suggestion,
  onLinkExisting,
  onCreateDraft,
  isCreatingDraft,
}: AfterFactWebAppClusterActionsProps) {
  const t = useTranslations(
    'designSystem.networkSettings.externalInventory.webApp',
  );

  return (
    <VStack
      gap={2}
      w="full"
      alignItems="stretch"
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      {onCreateDraft ? (
        <Button
          size="xs"
          variant="outline"
          alignSelf="flex-start"
          loading={isCreatingDraft}
          onClick={onCreateDraft}
        >
          {t('createDraft')}
        </Button>
      ) : null}
      {onLinkExisting ? (
        <AfterFactWebAppClusterLink
          applications={applications}
          suggestion={suggestion}
          onLinkExisting={onLinkExisting}
        />
      ) : null}
    </VStack>
  );
}
